import { render, staticRenderFns } from "./CertificateVerification.vue?vue&type=template&id=37b786e3&scoped=true&"
import script from "./CertificateVerification.vue?vue&type=script&lang=js&"
export * from "./CertificateVerification.vue?vue&type=script&lang=js&"
import style0 from "./CertificateVerification.vue?vue&type=style&index=0&id=37b786e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b786e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
